module.exports = __webpack_public_path__ + "static/img/news21-1.38e238b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news21-1.jpg
// module id = OpLz
// module chunks = 0